module.exports = __webpack_public_path__ + "img/star-citizen-640.db42ae97.jpg";